module.exports = __webpack_public_path__ + "img/zhaohuo_img_woman.c9fc3e81.png";